exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".damages-types {\n  position: relative;\n}\n.damages-types .container {\n  padding: 2rem;\n}\n.damages-types .view_content {\n  max-width: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.damages-types ul {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 1.2rem;\n  grid-row-gap: 1.2rem;\n}", ""]);

// exports
